export const addCountryToAddress = (address, countries) => {
    if (address.countryName)
        return address;
    const country = countries.find((_country) => _country.id === address.countryCode);
    return Object.assign(Object.assign({}, address), { countryName: country === null || country === void 0 ? void 0 : country.full_name_locale });
};
//# sourceMappingURL=transformCountryAddress.js.map